module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tasks":"@:labels.tasks","notes":"@:labels.notes","lead":"@:labels.lead","applicants":"@:labels.applicants"}}')
  delete Component.options._Ctor
}
